import { Building2, Palette } from "lucide-react";
import { useEffect, useState } from "react";

export function OrganizationBrandingPanel({ api, workspace, onUpdated }) {
  const [draft, setDraft] = useState(() => ({
    logoUrl: workspace.branding?.logoUrl || "",
    primaryColor: workspace.branding?.primaryColor || "#5b5bd6",
    reportFooter: workspace.branding?.reportFooter || "",
  }));
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    setDraft({
      logoUrl: workspace.branding?.logoUrl || "",
      primaryColor: workspace.branding?.primaryColor || "#5b5bd6",
      reportFooter: workspace.branding?.reportFooter || "",
    });
  }, [workspace]);

  async function submit(event) {
    event.preventDefault();
    setSaving(true);
    setError("");
    setSaved(false);
    try {
      const updated = await api.updateOrganizationBranding(draft);
      onUpdated?.(updated);
      setSaved(true);
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <section className="institution-card institution-branding-card">
      <header>
        <Palette size={20} />
        <div><h2>Identidad del espacio</h2><p>Logo, color visible y pie de reportes.</p></div>
      </header>
      <form onSubmit={submit}>
        <div
          className="institution-branding-preview"
          style={{ backgroundColor: draft.primaryColor }}
        >
          {draft.logoUrl
            ? <img src={draft.logoUrl} alt="Vista previa del logo" />
            : <Building2 size={24} />}
        </div>
        <label>
          Color
          <input
            type="color"
            value={draft.primaryColor}
            onChange={(event) => setDraft({
              ...draft,
              primaryColor: event.target.value,
            })}
          />
        </label>
        <label className="institution-branding-url">
          URL del logo
          <input
            type="url"
            value={draft.logoUrl}
            onChange={(event) => setDraft({ ...draft, logoUrl: event.target.value })}
            placeholder="https://…"
          />
        </label>
        <label className="institution-branding-footer">
          Pie de los reportes
          <input
            value={draft.reportFooter}
            maxLength={300}
            onChange={(event) => setDraft({
              ...draft,
              reportFooter: event.target.value,
            })}
            placeholder="Leyenda opcional"
          />
        </label>
        <button className="primary-button" disabled={saving}>
          {saving ? "Guardando…" : "Guardar identidad"}
        </button>
      </form>
      {error ? <p className="support-access-error">{error}</p> : null}
      {saved ? <p className="institution-form-success">Identidad actualizada.</p> : null}
    </section>
  );
}
